import React, { useState, useRef, useEffect } from 'react';
import { GridComponent, Inject, ColumnsDirective, ColumnDirective, Search, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { Header } from '../../../components'
import useAppwrite from '../../../lib/useAppwrite';
import { config, deleteDocument, getAllDocuments, getCurrentUser } from '../../../lib/appwrite';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../../contexts/ContextProvider';
import { FaEye, FaRegEdit } from 'react-icons/fa';
import { FaCirclePlus, FaTrashCan } from "react-icons/fa6";
// import EditUser from './EditUser';
import EditableTable from '../../../components/EditableTable';
import { TbEye, TbEyeCog } from "react-icons/tb";
import EditCustomer from './EditCustomer';
import ConfirmDelete from '../../../components/ConfirmDelete';


const Customers = () => {
  const { currentColor } = useStateContext();
  const [createCustomer, setCreateCustomer] = useState(false)
  const [editCustomer, setEditCustomer] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)

  // Table variables
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [reset, setReset] = useState(false)
  const [customers, setCustomers] = useState([])

  useEffect(() => {
    refetch()
  }, [editCustomer, createCustomer]);

  useEffect(() => {
    if (!selectedRowData) {
      setReset(true)
    }
  }, [selectedRowData])

  const handleRowSelect = (data) => {
    setSelectedRowData(data);
  };

  const handleDelete = async () => {
    setConfirmDelete(false)
    const response = await deleteDocument(selectedRowData.$id, config.customersCollectionId)
    refetch()
    setSelectedRowData(null)
  }

  // Data
  const { data: data, isLoading, refetch } = useAppwrite(
    () => getAllDocuments(config.customersCollectionId)
  );

  useEffect(() => {
    if (data) {
      setCustomers(data);
    }
  }, [data]);
  // ======================================== Edit QualityRecord Vars ======================================== //

  return (
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
      <div className={`${createCustomer ? 'block' : 'hidden'} overflow-scroll`}>
        <EditCustomer view={createCustomer} setView={setCreateCustomer} selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData} mode={'create'} />
      </div>
      <div className={`${editCustomer ? 'block' : 'hidden'} overflow-scroll`}>
        <EditCustomer view={editCustomer} setView={setEditCustomer} selectedRowData={selectedRowData} setSelectedRowData={setSelectedRowData} mode={'edit'} />
      </div>
      <Header category="" title="Customers" isLoading={isLoading} />

      <div className='flex flex-1 justify-end items-center my-2'>
        <TooltipComponent content="Create Testimonial" position='TopCenter'>
          <button
            type='button'
            onClick={() => setCreateCustomer(true)}
            style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
            className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
          >
            <FaCirclePlus className='text-xl' style={{ color: currentColor }} />
          </button>
        </TooltipComponent>
        <div className={`${selectedRowData ? 'block' : 'hidden'}`}>
          <TooltipComponent content="Review Testimonial" position='TopCenter'>
            <button
              type='button'
              onClick={() => setEditCustomer(true)}
              style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
              className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
            >
              <FaRegEdit className='text-xl' style={{ color: currentColor }} />
            </button>
          </TooltipComponent>
        </div>
        <div className={`${selectedRowData ? 'block' : 'hidden'}`}>
          <TooltipComponent content="Delete Testimonial" position='TopCenter'>
            <button
              type='button'
              onClick={() => setConfirmDelete(true)}
              style={{ borderRadius: '50%' }}
              className='text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray'
            >
              <FaTrashCan className='text-xl text-red-500' />
            </button>
          </TooltipComponent>
        </div>
      </div>
      <EditableTable
        title=""
        data={customers}
        setData={setCustomers}
        rowActions={[]}
        keyMapping={{
          'Name': 'name',
          'Phone': 'phone',
          'Email': 'email',
        }}
        onRowClick={handleRowSelect} // Assuming handleRowSelect is a defined function
        reset={reset}
        setReset={setReset}
        selectable={true}
      />
      <ConfirmDelete
        title="Confirm Deletion?"
        text="Are you sure you want to delete the following? This action cannot be undone."
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
        visible={confirmDelete}
        setVisible={setConfirmDelete}
        handleConfirm={() => handleDelete()}
      />
    </div>
  );
};

export default Customers;